import { useEffect, useRef } from 'react';

// Pins layers to a declared paint order, bottom to top. `Layer` adds with no `beforeId`, which
// appends to the top -- fine on first mount, wrong for a layer that unmounts and comes back, which
// then paints over the highlights above it.
//
// Render as the LAST child of the map so this runs after every `Layer` has added. Unknown ids are
// skipped.
function LayerOrder({ map, ids }) {
    const previous = useRef([]);
    const key = ids.join('|');

    useEffect(() => {
        if (!map) return;

        const known = previous.current;
        previous.current = ids;

        // Only an addition can disorder the stack; removals leave the rest in place.
        if (!ids.some((id) => !known.includes(id))) return;

        // `moveLayer` with no `beforeId` moves to the top, so replaying front to back restores it.
        ids.forEach((id) => {
            if (map.getLayer(id)) map.moveLayer(id);
        });
        // Keyed on the joined ids: callers build the array fresh every render.
    }, [map, key]);

    return null;
}

export default LayerOrder;
